import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class LibraryProxy extends ProxyBase {
  postCreatePortfolio(params) {
    return this.post('Portfolio/AddNewPortfolio', params)
  }

  getSearchPortfolio(params) {
    return this.get('Library/SearchPortfolio', params)
  }

  postCopyCompany(params) {
    return this.post('Library/CopyCompanies', params)
  }
}

export default new LibraryProxy()
